var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jm-button",class:'button_'+_vm.status,on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }